import React from "react";
import { useTypewriter, Cursor } from "react-simple-typewriter";

const LeftBanner = () => {
  const [text] = useTypewriter({
    words: ["Professional Coder.", "FullStack Developer.", "Engineer."],
    loop: true,
    typeSpeed: 20,
    deleteSpeed: 10,
    delaySpeed: 2000,
  });
  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20">
      <div className="flex flex-col gap-5">
        <h4 className=" text-lg font-normal">WELCOME TO MY WORLD</h4>
        <h1 className="text-6xl font-bold text-white">
          Hi, I'm{" "}
          <span className="text-designColor capitalize">Sodiq Alabi</span>
        </h1>
        <h2 className="text-4xl font-bold text-white">
          <span>{text}</span>
          <Cursor
            cursorBlinking="false"
            cursorStyle="|"
            cursorColor="#ff014f"
          />
        </h2>
        <p className="text-base font-bodyFont leading-6 tracking-wide">
          Dedicated Software Developer skilled in crafting efficient and
          scalable applications. Proficient in C#, JavaScript, .NET
          Technologies, Angularjs, and React, with expertise in database management.
          Demonstrated success in delivering high-quality software solutions
          using Agile methodologies, specifically Scrum. Eager to contribute to
          innovative projects and bring a proven track record of excellence to
          the table..
        </p>
      </div>
      {/* Media */}
      {/* <Media /> */}
    </div>
  );
};

export default LeftBanner;
